import { Close } from '@/components/icons'
import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useMemo } from 'react'
import { ProviderRevenueCat } from '@/pages/external/ExternalPremiumLogin/RevenueCatProvider'
import { RevenueCatPurchase } from '@/pages/external/RevenuecatCheckout'
import { useRemoteConfig } from '@/hooks/useRemoteConfig'

type Props = {
  open: boolean
  onClose: () => void
}

export const SubscribeModal = ({ open, onClose }: Props) => {
  const { getBoolean, isReady } = useRemoteConfig()
  const enableSubscribeModal = getBoolean('enableWebSubscribeModal', false)
  const shouldShow = useMemo(() => {
    if (isReady) {
      if (open && enableSubscribeModal) {
        return true
      }
    }

    return false
  }, [enableSubscribeModal, isReady, open])

  const handleCloseModal = () => {
    onClose()
  }

  return (
    <Transition appear show={shouldShow} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={handleCloseModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-[640px] flex flex-col h-screen md:h-auto min-h-[550px] transform overflow-y-auto md:rounded-[32px] pt-6 md:py-4 pb-4 bg-white text-left align-middle shadow-xl transition-all relative">
                <div className="flex items-center justify-between px-4">
                  <button
                    className="w-9 h-9 rounded-full bg-navy-900 bg-opacity-10 flex items-center justify-center hover:bg-opacity-20"
                    onClick={handleCloseModal}
                  >
                    <Close className="text-navy-900" />
                  </button>
                  <Dialog.Title as="h3" className="text-xl text-navy-900 font-semibold text-center">
                    Subscribe
                  </Dialog.Title>
                  <div className="w-9 h-9" />
                </div>

                <div className="flex flex-1 items-center justify-center">
                  <ProviderRevenueCat>
                    <RevenueCatPurchase isModal={true} />
                  </ProviderRevenueCat>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
